/**
 * Nombres de estados del ámbito Booking que este módulo compara por literal.
 *
 * El catálogo escribe «Enviado nota de crédito» CON tilde (Estado 56), y cuatro comparaciones
 * del módulo lo escribían sin tilde: nunca coincidían, y con el booking ya en ese estado el botón
 * de Nota de Crédito quedaba gris para siempre — Finanzas no podía emitir la complementaria
 * (bug #40953, 45 bookings atrapados en Ecuador UAT). Un solo lugar para que no vuelva a divergir.
 */
export const ESTADO_ENVIADO_A_FACTURAR = 'Enviado a facturar'

export const ESTADO_ENVIADO_NOTA_CREDITO = 'Enviado nota de crédito'
